import React, {useEffect} from "react";
import {useTypedSelector} from "helpers/reducers";
import BookingLoginAction from "store/bookingLogin/BookingLoginAction";
import useNavigation, {RouteName} from "utils/hooks/useNavigation";
import {useDispatch} from "useDispatch";
import {Driver} from "types/entities/Driver";
import SessionAction from "store/session/SessionAction";
import HallAction from "store/hall/HallAction";
import {DEFAULT_HALL_ID} from "helpers/config";
import {ThunkAction} from "redux-thunk";
import BookingAction from "store/booking/BookingAction";

interface BookingLoginLayoutProps {
    children: React.ReactNode | React.ReactNode[];
}

const BookingLoginLayout = (props: BookingLoginLayoutProps) => {
    const dispatch = useDispatch();
    const {historyPush} = useNavigation();
    const session = useTypedSelector(state => state.sessionState.session);
    const profile: Driver | null = useTypedSelector(state => state.bookingLoginState.user);

    useEffect(() => {
        if (!session || session && session.user && session.user.id == 3) {
            dispatch(BookingLoginAction.resetBookingLoginState());
            historyPush(RouteName.BookingLogin);
        }
    }, [session]);

    useEffect(() => {
        if (!profile) {
            const run = async () => {
                await dispatch(BookingLoginAction.fetchReservationsLogout()).then(r => {
                    dispatch(SessionAction.loginVisitor());
                    dispatch(HallAction.fetchHall(DEFAULT_HALL_ID)).then(r => {});
                    dispatch<ThunkAction<any, any, any, any>>(BookingAction.fetchActivities());
                });
                historyPush(RouteName.BookingLogin);
            };
            run().then(r => {});
        }
    }, [profile]);

    return (
        <>
            {props.children}
        </>
    );
};

export default BookingLoginLayout;